// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/generations/v1/set_generation_mask_regions.proto (package protos.vision.generations.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { MaskRegion } from "./mask_region_pb";
import { file_vision_generations_v1_mask_region } from "./mask_region_pb";
import type { VisionGeneration } from "./vision_generation_pb";
import { file_vision_generations_v1_vision_generation } from "./vision_generation_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/generations/v1/set_generation_mask_regions.proto.
 */
export const file_vision_generations_v1_set_generation_mask_regions: GenFile = /*@__PURE__*/
  fileDesc("Cjd2aXNpb24vZ2VuZXJhdGlvbnMvdjEvc2V0X2dlbmVyYXRpb25fbWFza19yZWdpb25zLnByb3RvEhxwcm90b3MudmlzaW9uLmdlbmVyYXRpb25zLnYxItMBCh9TZXRHZW5lcmF0aW9uTWFza1JlZ2lvbnNSZXF1ZXN0ElQKBnBhcmFtcxgBIAEoCzJELnByb3Rvcy52aXNpb24uZ2VuZXJhdGlvbnMudjEuU2V0R2VuZXJhdGlvbk1hc2tSZWdpb25zUmVxdWVzdC5QYXJhbXMaWgoGUGFyYW1zEhUKDWdlbmVyYXRpb25faWQYASABKAkSOQoHcmVnaW9ucxgCIAMoCzIoLnByb3Rvcy52aXNpb24uZ2VuZXJhdGlvbnMudjEuTWFza1JlZ2lvbiLHAQogU2V0R2VuZXJhdGlvbk1hc2tSZWdpb25zUmVzcG9uc2USVQoGcmVzdWx0GAEgASgLMkUucHJvdG9zLnZpc2lvbi5nZW5lcmF0aW9ucy52MS5TZXRHZW5lcmF0aW9uTWFza1JlZ2lvbnNSZXNwb25zZS5SZXN1bHQaTAoGUmVzdWx0EkIKCmdlbmVyYXRpb24YASABKAsyLi5wcm90b3MudmlzaW9uLmdlbmVyYXRpb25zLnYxLlZpc2lvbkdlbmVyYXRpb25iBnByb3RvMw", [file_vision_generations_v1_mask_region, file_vision_generations_v1_vision_generation]);

/**
 * @generated from message protos.vision.generations.v1.SetGenerationMaskRegionsRequest
 */
export type SetGenerationMaskRegionsRequest = Message<"protos.vision.generations.v1.SetGenerationMaskRegionsRequest"> & {
  /**
   * @generated from field: protos.vision.generations.v1.SetGenerationMaskRegionsRequest.Params params = 1;
   */
  params?: SetGenerationMaskRegionsRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.generations.v1.SetGenerationMaskRegionsRequest.
 * Use `create(SetGenerationMaskRegionsRequestSchema)` to create a new message.
 */
export const SetGenerationMaskRegionsRequestSchema: GenMessage<SetGenerationMaskRegionsRequest> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_set_generation_mask_regions, 0);

/**
 * @generated from message protos.vision.generations.v1.SetGenerationMaskRegionsRequest.Params
 */
export type SetGenerationMaskRegionsRequest_Params = Message<"protos.vision.generations.v1.SetGenerationMaskRegionsRequest.Params"> & {
  /**
   * @generated from field: string generation_id = 1;
   */
  generationId: string;

  /**
   * @generated from field: repeated protos.vision.generations.v1.MaskRegion regions = 2;
   */
  regions: MaskRegion[];
};

/**
 * Describes the message protos.vision.generations.v1.SetGenerationMaskRegionsRequest.Params.
 * Use `create(SetGenerationMaskRegionsRequest_ParamsSchema)` to create a new message.
 */
export const SetGenerationMaskRegionsRequest_ParamsSchema: GenMessage<SetGenerationMaskRegionsRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_set_generation_mask_regions, 0, 0);

/**
 * @generated from message protos.vision.generations.v1.SetGenerationMaskRegionsResponse
 */
export type SetGenerationMaskRegionsResponse = Message<"protos.vision.generations.v1.SetGenerationMaskRegionsResponse"> & {
  /**
   * @generated from field: protos.vision.generations.v1.SetGenerationMaskRegionsResponse.Result result = 1;
   */
  result?: SetGenerationMaskRegionsResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.generations.v1.SetGenerationMaskRegionsResponse.
 * Use `create(SetGenerationMaskRegionsResponseSchema)` to create a new message.
 */
export const SetGenerationMaskRegionsResponseSchema: GenMessage<SetGenerationMaskRegionsResponse> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_set_generation_mask_regions, 1);

/**
 * @generated from message protos.vision.generations.v1.SetGenerationMaskRegionsResponse.Result
 */
export type SetGenerationMaskRegionsResponse_Result = Message<"protos.vision.generations.v1.SetGenerationMaskRegionsResponse.Result"> & {
  /**
   * @generated from field: protos.vision.generations.v1.VisionGeneration generation = 1;
   */
  generation?: VisionGeneration | undefined;
};

/**
 * Describes the message protos.vision.generations.v1.SetGenerationMaskRegionsResponse.Result.
 * Use `create(SetGenerationMaskRegionsResponse_ResultSchema)` to create a new message.
 */
export const SetGenerationMaskRegionsResponse_ResultSchema: GenMessage<SetGenerationMaskRegionsResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_set_generation_mask_regions, 1, 0);

